var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 15,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3F4851",
  d: "M14.747 13.44H1.253a.586.586 0 0 0-.586.586v.66c0 .08.066.147.146.147h14.374c.08 0 .146-.066.146-.147v-.66a.586.586 0 0 0-.586-.587M3.337 11.9a1 1 0 0 0 .11-.01l3.085-.54a.2.2 0 0 0 .097-.052L14.4 3.527a.183.183 0 0 0 0-.259L11.353.219a.18.18 0 0 0-.13-.053.18.18 0 0 0-.13.053L3.32 7.991a.2.2 0 0 0-.05.097l-.542 3.084a.61.61 0 0 0 .173.546.62.62 0 0 0 .436.181"
})));
export { SvgEdit as ReactComponent };
export default __webpack_public_path__ + "Edit.faca30c3.svg";